import { render, staticRenderFns } from "./tokenInput.vue?vue&type=template&id=e0940b5e"
import script from "./tokenInput.vue?vue&type=script&lang=js"
export * from "./tokenInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports